"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketoService = void 0;
class MarketoService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    postApiV1MarketoSent({ serviceType, requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/marketo/sent/{serviceType}',
            path: {
                serviceType: serviceType,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV1MarketoSent() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/marketo/sent',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV1MarketoSettings({ serviceType, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/marketo/settings/{serviceType}',
            path: {
                serviceType: serviceType,
            },
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.MarketoService = MarketoService;
